<div class="table-label" [style]="labelsGridSize">
  @for (label of labels; track label; let index = $index; let isLast = $last) {
    <div class="table-label-inner">
      <span [attr.data-cy]=getDataCyLabelElement(index)>{{label}}</span>
      @if (!isLast) {
        <div
          class="table-bold-separator"
        [style]="separatorHeight"></div>
      }
    </div>
  }
</div>
